import { useMemo } from 'react'
import { isEmpty } from 'ramda'

import SimpleDate from 'app/common/classes/simple-date'
import {
  Table,
  useCopyColumnsWidths,
} from 'app/common/ui-components/table'

import { SkeletonLoadingTBody, StatusMessage } from 'app/common/templates-next/page-template'
import { useCompensationTransactions } from 'app/dataProviders/cafeteria/compensation/transactions/hooks'
import ScrollbarsWShadow from 'app/common/ui-components/scrollbars-w-shadow'
import { useColumnProps, useColumnTitles, useColumnsArranged, useHeaderColumnProps } from './columns'
import { TableHeader } from './TableHeader'
import { TableRow } from './TableRow'


type Props = {
  studentID: string
  supplierID: string
  periodFrom: string
  periodTo: string
  periodFormat: string
  currency: string
}

export const CompensationHistoryTable = ({
  studentID,
  supplierID,
  periodFrom,
  periodTo,
  periodFormat,
  currency,
}: Props) => {
  const params = useMemo(() => {
    const dateFrom = new SimpleDate(periodFrom, periodFormat)
    const dateTo = new SimpleDate(periodTo, periodFormat)
    return { studentID, supplierID, dateFrom, dateTo }
  }, [studentID, supplierID, periodFrom, periodTo, periodFormat])

  const { transactions, loading } = useCompensationTransactions(params)

  const nothing = isEmpty(transactions)

  const columns = useColumnsArranged()
  const titles = useColumnTitles(currency)
  const headerColumnProps = useHeaderColumnProps()
  const columnProps = useColumnProps()
  const [refFrom, refTo] = useCopyColumnsWidths()
  // const [updateRowNode, calcTopShift, nodes] = useTopShiftState()

  return (

    <div style={{
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      flex: 1,
    }}
    >
      <Table>
        <thead>
          <TableHeader
            reference={refTo}
            columns={columns}
            titles={titles}
            stuck
            shadow={false}
            columnProps={headerColumnProps}
          />
        </thead>
      </Table>
      <div style={{
        display: 'flex',
        position: 'relative',
        flex: 1,
      }}
      >
        <ScrollbarsWShadow>
          <Table wide>

            <tbody>
              {loading
                && <SkeletonLoadingTBody
                  rows={transactions.length || 5}
                  columns={columns.length}
                  onlyRows
                />}

              {nothing
                && !loading
                && <StatusMessage asTableRow colSpan={columns.length}>
                  {'Нет записей, удовлетворяющих условиям'}
                </StatusMessage>}

              {!nothing
                && !loading
                && transactions.map(transaction => (
                  <TableRow
                    reference={refFrom}
                    key={transaction.ID}
                    columns={columns}
                    columnProps={columnProps}
                    transaction={transaction}
                  />
                ))}

            </tbody>
          </Table>
        </ScrollbarsWShadow>
      </div>
    </div>
  )
}
